import { render, staticRenderFns } from "./UploadForCompanyModal.vue?vue&type=template&id=7d9d8505&scoped=true&"
import script from "./UploadForCompanyModal.vue?vue&type=script&lang=ts&"
export * from "./UploadForCompanyModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d9d8505",
  null
  
)

export default component.exports